"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeRegExpString = function (string) { return string.replace(/[\\^$.|?*{}+()[\]]/g, '\\$&'); };
exports.DEFAULT_MAX_WIDTH_TOOLTIP = '720px';
//# sourceMappingURL=helpers.js.map